import { makeAutoObservable } from "mobx"
import Logger from "../services/Logger"
import { RootStore } from "./RootStore"

export const bottomNavLabels = [
    'Chats',
    'Jukebox',
    'Dashboard',
    'Dateship'
]

export const navPaths = [
    '/stapp/imchats',
    '/stapp/jukebox',
    '/stapp/dashboard',
    '/stapp/dateship'
]

const appBarPaths = [
    '/stapp/home',
    '/stapp/vnotes',
    '/stapp/imchats',
    '/stapp/dashboard',
    '/stapp/dateship',
    '/stapp/jukebox',
]

export default class UIStore{

    rootStore: RootStore
    bottomNavIndex: number = 0
    appBarVisible: boolean = false
    currentPath = ''

    constructor(rootStore: RootStore){
        this.rootStore = rootStore
        makeAutoObservable(this,{
            rootStore: false
        })

        this.appBarVisible = false
        console.log('Current location '+window.location.href)
        const splittedLoc = window.location.href.split('/')
        // if(rootStore.mainStore.uid)
        //  this.appBarVisible = true
        if(splittedLoc[3].length > 0)
         this.updateHistoryPath('/'+splittedLoc[3]+'/'+splittedLoc[4])
        else{
            if(this.rootStore.mainStore.uid != null)
             this.appBarVisible = true
        }
         
         
    }

    updateBottomNavIndex(index: number){
        this.bottomNavIndex = index
    }

    updateHistoryPath(path: string){
        console.log('Current location splitted '+path)
        this.currentPath = path

        //update bottom nav index acccordingly
        const index = navPaths.findIndex((item) => item == path)
        if(index > -1)
         this.updateBottomNavIndex(index)

        Logger.debug(this.rootStore.mainStore.uid, 'UID')
        if(path == '/' && this.rootStore.mainStore.uid != null){
            this.appBarVisible = true
            return
        }
        
        if(appBarPaths.includes(path) && this.rootStore.mainStore.uid != null){
            if(this.appBarVisible){}
             else
             this.appBarVisible = true
        }
        else{
            if(this.appBarVisible)
             this.appBarVisible = false
        }
    }

}